import React, { useState, useEffect } from "react";
import { Form, Switch, Row, Col, Checkbox, Button, Spin, message } from "antd";
import { connect } from "react-redux";
import { setBreakTypesList, setRoleList } from "redux/actions";
import {
  getClientid,
  getLocations,
  getAllDepartmentList,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import { CALL_API } from "common/API";
import { STATUS_CODE, VALIDATE_CHARACTER, VALIDATE_SYMBOL_CHARACTER } from "common/Constants";
import EditInformation from "molecules/EditInformation";
import EditSelectTable from "molecules/EditSelectTable";
import TabsList from "molecules/TabsList";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FormModal from "./FormModal";
import styled from "styled-components";
import { LoadingOutlined } from '@ant-design/icons';

const EditBreak = ({
  isModalVisible,
  closeModal,
  setBreakTypes,
  ClientId,
  getBreakList,
  BreakDetails,
  locationList,
  departmentList,
  //need for delete
  deleteBreak,
  viewOnly,
  saveRoleList
}) => {
  const [form] = Form.useForm();

  const fetchMasterData = async (fetch_master_data) => {
    const { code, breakList, roleList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        setBreakTypes(breakList);
        saveRoleList(roleList);
      }
    }
  };

  const [selectDepartmentId, setSelectDepartmentId] = useState([]);
  const [submit, setsubmit] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [create, setCreate] = useState(false);
  const [values, setValues] = useState({});
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [selectAllDepartmentsChecked, setSelectAllDepartmentsChecked] =
    useState(false);
  const [selectAllLocationChecked, setSelectAllLocationChecked] =
    useState(false);

  useEffect(() => {
    setValues({ name: BreakDetails.breakName });
    setSelectedLocationId(BreakDetails.locationId);
    setSelectDepartmentId(BreakDetails.departmentId);
    setSelectAllLocationChecked(
      selectDepartmentId.length === departmentList.length
    );
  }, [BreakDetails]);

  useEffect(() => {
    form.setFieldsValue({
      break_name: BreakDetails.breakName,
    });
    setSelectAllLocationChecked(
      selectedLocationId.length === locationList.length
    );
    setSelectAllDepartmentsChecked(
      selectDepartmentId.length === departmentList.length
    );
  }, [
    BreakDetails,
    selectedLocationId,
    locationList,
    selectDepartmentId,
    departmentList,
  ]);

  const departmentcolumns = [
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => {
        const check = selectDepartmentId?.includes(department_id)
          ? true
          : false;
        return (
          <Switch
            disabled={viewOnly}
            checked={check}
            size="small"
            onChange={(checked) => getDepartmentId(department_id, checked)}
          />
        );
      },
    },
  ];

  const getDepartmentId = (department_id, checked) => {
    const newDepartmentId = checked
      ? [...selectDepartmentId, department_id]
      : selectDepartmentId.filter((item) => item !== department_id);
    setSelectDepartmentId(newDepartmentId);
    setsubmit(true);
  };

  const handleSelectAllDepartmentsChange = (e) => {
    const checked = e.target.checked;
    setSelectAllDepartmentsChecked(checked);
    const allDepartmentIds = departmentList.map((item) => item.department_id);
    setSelectDepartmentId(checked ? allDepartmentIds : []);
    setsubmit(true);
  };

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        const check = selectedLocationId?.includes(location_id) ? true : false;
        return (
          <Switch
            disabled={viewOnly}
            size="small"
            checked={check}
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
    setsubmit(true);
  };

  const handleSelectAllLocationChange = (e) => {
    const checked = e?.target?.checked;
    setSelectAllLocationChecked(checked);
    const allDepaetmentIds = locationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allDepaetmentIds : []);
    setsubmit(true);
  };

  const handleSubmit = async () => {
    setCreate(true);
    const { name } = values;
    const containsSpecialCharacters = !VALIDATE_SYMBOL_CHARACTER.test(name); 
    if (containsSpecialCharacters) { // Handle the case where BreakName contains special characters
      return; // Prevent further execution
    }
    const { code } = await CALL_API(
      `owner-break/${ClientId}/${BreakDetails.breakId}`,
      "patch",
      {
        breakname: name,
        locationid: selectedLocationId,
        departmentid: selectDepartmentId,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      setCreate(false);
      fetchMasterData(true);
      getBreakList();
      message.success("Break has been updated successfully");
    } else {
      setCreate(false);
    }
  };
  const handleSave = async () => {
    await handleSubmit(); // Ensure API call finishes before navigating
    closeModal();
  };

  // useEffect(() => {
  //   if (submit) {
  //     handleSubmit();
  //   }
  // }, [selectDepartmentId, selectedLocationId, values]);

  const items = [
    {
      id: 1,
      label: "Basic",
      component: (
        <>
          {viewOnly ? (
            <Row className="styled-card">
              <Col>
                <b>Break Name</b> : {values.name}
              </Col>
            </Row>
          ) : (
            <EditInformation
              details={BreakDetails}
              setValues={setValues}
              create={create}
              title="break"
              setsubmit={setsubmit}
            />
          )}
        </>
      ),
    },
    {
      id: 2,
      label: "Department",
      component: (
        <>
          {!viewOnly && (
            <div className="mb-3 d-flex justify-content-between">
              {departmentList?.length > 0 && (
                <Checkbox
                  className=""
                  checked={selectAllDepartmentsChecked}
                  onChange={handleSelectAllDepartmentsChange}
                >
                  Select All
                </Checkbox>
              )}
            </div>
          )}
          <EditSelectTable
            columns={departmentcolumns}
            tabledata={departmentList}
            setOpenModal={() => setOpenDepartmentModal(true)}
            Name="Add Department"
          />
          <FormModal
            isModalVisible={openDepartmentModal}
            closeModal={() => setOpenDepartmentModal(false)}
            Name="Department"
          />
        </>
      ),
    },
    {
      id: 3,
      label: "Location",
      component: (
        <>
          {!viewOnly && (
            <div className="mb-3 d-flex justify-content-between">
              {locationList?.length > 0 && (
                <Checkbox
                  className=""
                  checked={selectAllLocationChecked}
                  onChange={handleSelectAllLocationChange}
                >
                  Select All
                </Checkbox>
              )}
            </div>
          )}

          <EditSelectTable
            columns={locatincolumns}
            tabledata={locationList}
            setOpenModal={() => setOpenLocationModal(true)}
            Name="Add Location"
          />
          <FormModal
            isModalVisible={openLocationModal}
            closeModal={() => setOpenLocationModal(false)}
            Name="Location"
          />
        </>
      ),
    },
  ];

  return (
    <>
      {isModalVisible && (
        <>
        <BreakStyle>
          <div className="d-flex justify-content-between">
            <div className="break_header_content">
              <label
                className="bg-transparent border-0 mb-3 text-left styled-cursor"
                onClick={() => {
                  closeModal(false);
                }}
              >
              Break <ArrowForwardIosIcon className="px-1" />
              </label>{" "}
              <b className=" pb-0 pt-1">{values.name}</b>
            </div>
            <div className="break_header_action">
              <Button type="primary" onClick={handleSave}>{create && <Spin indicator={<LoadingOutlined spin />} />}Save</Button>
            </div>
          </div>
        </BreakStyle>
          
          <TabsList items={items} />
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  locationList: getLocations(state),
  departmentList: getAllDepartmentList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setBreakTypes: setBreakTypesList,
      saveRoleList: setRoleList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps, null)(EditBreak);

const BreakStyle = styled.div`
  .break_header_content{
    width: max-content;
  }
  .break_header_action{
    width: 20px;
    height: 20px;
    width: max-content;
  }
`;